import React from "react";
import styles from "./blog-card.module.scss";
import Button, { BTN_VARIANTS } from "../Button";
import Card from ".";
const BlogCard = ({ data }) => {
  return (
    <Card className={styles.root}>
      <span className={styles.date}>{data.date}</span>
      <span className={styles.title}>{data.title}</span>
      <span className={styles.description}>{data.description}</span>
      <Button
        variant={BTN_VARIANTS.secondary}
        onClick={() => window.open(data.btn.link)}
        className={styles.btn}
      >
        <span className={styles["btn-title"]}>{data.btn.title}</span>
      </Button>
    </Card>
  );
};

export default BlogCard;
